// import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
import config from "@/configs/config.js";
import { v4 as uuidv4 } from "uuid";

const sanitizeInput = (inp) => {
  inp = inp.replace("'", "&quot");
  // inp = inp.replace('\"','&dquot');
  inp = inp.replace("=", "&equal");
  return inp;
};

const formatDateString = (dateString, type) => {
  //example args "2022-12-01"
  let date = new Date(dateString);
  return formatDate(date, type);
};

const strToDate = (_dateStr, inputFormat) => {
  // Handle null, undefined, atau empty string
  if (!_dateStr || _dateStr === null || _dateStr === undefined || _dateStr === '') {
    return null;
  }

  let newDate = null;

  if (inputFormat.toLowerCase() == "dd/mm/yyyy hh:mm:ss") {
    let date = _dateStr.split(" ")[0];
    let day = date.split("/")[0];
    let month = date.split("/")[1];
    let year = date.split("/")[2];

    let time = "00:00:00";
    if (_dateStr.split(" ").length > 1) {
      time = _dateStr.split(" ")[1];
    }

    newDate = new Date(`${year}-${month}-${day}T${time}`);
  } else if (inputFormat.toLowerCase() == "dd/mm/yyyy") {
    let date = _dateStr.split(" ")[0];
    let day = date.split("/")[0];
    let month = date.split("/")[1];
    let year = date.split("/")[2];

    let time = "00:00:00";

    newDate = new Date(`${year}-${month}-${day}T${time}`);
  }

  return newDate;
};

const thousandSeparator= (val) => {
  if (typeof val !== 'number') {
    return val;
  }
  
  let stringValue = val.toString();
  let [integerPart, decimalPart] = stringValue.split('.');
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  
  if (decimalPart) {
    return integerPart + '.' + decimalPart;
  } else {
    return integerPart;
  }
}

const formatDate = (_date, type) => {
  if (!_date) return null;

  let date = new Date(_date);
  let year = date.getFullYear();
  let actMonth = date.getMonth() + 1;
  let month = actMonth < 10 ? "0" + actMonth : actMonth; //getMonth begin at 0
  let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

  let formattedDate = "";
  if (type == "date") {
    formattedDate = `${day}/${month}/${year}`;
  } else if (type == "datetime") {
    let hour = date.getHours() >= 10 ? date.getHours() : "0" + date.getHours();
    let minute =
      date.getMinutes() >= 10 ? date.getMinutes() : "0" + date.getMinutes();
    // let second = date.getSeconds();

    formattedDate = `${day}/${month}/${year} ${hour}:${minute}`;
  } else if (type == "timestamp") {
    let hour = date.getHours() >= 10 ? date.getHours() : "0" + date.getHours();
    let minute =
      date.getMinutes() >= 10 ? date.getMinutes() : "0" + date.getMinutes();
    let second = date.getSeconds();

    formattedDate = `${day}/${month}/${year}T${hour}:${minute}:${second}`;
  }
  return formattedDate;
};

const sampleFunction = () => {
  return "A sample!";
};

const jsonReplacer = (match, pIndent, pKey, pVal, pEnd) => {
  var key = "<span class=json-key>";
  var val = "<span class=json-value>";
  var str = "<span class=json-string>";
  var r = pIndent || "";
  if (pKey) r = r + key + pKey.replace(/[": ]/g, "") + "</span>: ";
  if (pVal) r = r + (pVal[0] == '"' ? str : val) + pVal + "</span>";
  return r + (pEnd || "");
};

const isJson = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }

  return true;
};

const isPhp = (str) => {
  var pattern = /<\?php|<\?|\?>/;

  return pattern.test(str);
};

const jsonPrettyPrint = (obj) => {
  var jsonLine = /^( *)("[\w]+": )?("[^"]*"|[\w.+-]*)?([,[{])?$/gm;
  return JSON.stringify(obj, null, 3)
    .replace(/&/g, "&amp;")
    .replace(/\\"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(jsonLine, jsonReplacer);
};

const sanitizeWhitespace = (inp) => {
  return /\s/.test(inp);
};

const checkPasswordStrength = (pwd) => {
  var checkUpperCase = /[A-Z]/;
  var checkLowerCase = /[a-z]/;
  var checkNumber = /\d/;
  var checkSpecial = /(?=.*[!@#$%^&*])/;

  var pwdLength = pwd.length > 7 ? true : false;
  var hasUpperCase = checkUpperCase.test(pwd);
  var hasLowerCase = checkLowerCase.test(pwd);
  var hasNumber = checkNumber.test(pwd);
  var hasSpecial = checkSpecial.test(pwd);

  var checkedPwd = {
    pwdLength: false,
    hasUpperCase: false,
    hasLowercase: false,
    hasNumber: false,
    hasSpecial: false,
  };

  if (
    pwdLength === true &&
    hasUpperCase === true &&
    hasLowerCase === true &&
    hasNumber === true &&
    hasSpecial === true
  ) {
    checkedPwd = {
      pwdLength: pwdLength,
      hasUpperCase: hasUpperCase,
      hasLowerCase: hasLowerCase,
      hasNumber: hasNumber,
      hasSpecial: hasSpecial,
    };
  } else {
    checkedPwd = {
      pwdLength: pwdLength,
      hasUpperCase: hasUpperCase,
      hasLowerCase: hasLowerCase,
      hasNumber: hasNumber,
      hasSpecial: hasSpecial,
    };
  }

  return checkedPwd;
};

const checkValidEmail = (email) => {
  return /.+@.+\..+/.test(email);
};

const checkValidPhoneNumber = (phoneNumber) => {
  var isValid = false;
  const cleanPhoneNumber = phoneNumber.replace(/[^0-9-]/g, "");

  // Check if the number has 10 to 12 digits
  if (cleanPhoneNumber.length < 9 || cleanPhoneNumber.length > 12) {
    isValid = false;
  } else {
    isValid = true;
  }

  return isValid;
};

const checkWhiteSpace = (val) => {
  return /^\s*$/.test(val);
};

// const showAlert = (config) => {
//   const { errHandlerPage, options, preConfirmCallback } = config;

//   Swal.fire({
//     icon: options.icon,
//     title: options.title,
//     confirmButtonText: options.confirmButtonText,
//     confirmButtonColor: "#26A69A",
//     didOpen: () => {
//       const modal = Swal.getPopup();
//       const modalContainer = Swal.getContainer();

//       modal.style.width = errHandlerPage === "api" ? "300px" : "350px";
//       modal.style.height = errHandlerPage === "api" ? "200px" : "250px";
//       modalContainer.style.zIndex = "2011";

//       applyModalStyles(errHandlerPage, modal);
//     },
//     preConfirm: () => {
//       if (preConfirmCallback && typeof preConfirmCallback === "function") {
//         preConfirmCallback();
//       }
//     },
//     willClose: () => {
//       const modalContainer = Swal.getContainer();
//       if (options.mutation) {
//         modalContainer.removeEventListener("click", options.mutation());
//       }
//     },
//   });
// };

// const applyModalStyles = (errHandlerPage, modal) => {
//   const iconElement = modal.querySelector(".swal2-icon");
//   iconElement.style.fontSize = errHandlerPage === "api" ? "10px" : "12px";

//   const titleElement = modal.querySelector(".swal2-title");
//   titleElement.style.fontSize = errHandlerPage === "api" ? "18px" : "14px";
//   titleElement.style.margin = 0;
//   titleElement.style.padding = 0;

//   const actionGroup = modal.querySelector(".swal2-actions");
//   actionGroup.style.margin = 0;

//   const confirmButtonElement = modal.querySelector(".swal2-confirm");
//   confirmButtonElement.style.fontSize = "12px";
//   confirmButtonElement.style.width = "60px";
//   confirmButtonElement.style.height = "35px";
// };

const formValidation = (forms) => {
  let isValid = true;
  for (const key in forms) {
    if (forms[key].validation) {
      let formValue = forms[key].value;

      forms[key].warning = null;
      for (let i = 0; i < forms[key].validation.length; i++) {
        let v = forms[key].validation[i];

        let validationRes = v(formValue);
        if (validationRes != null) {
          forms[key].warning = validationRes;
          isValid = false;
        }
      }
    }
  }
  return isValid;
};

const singleFormValidation = (form) => {
  let isValid = true;
  if (form.validation) {
    let formValue = form.value;

    form.warning = null;
    for (let i = 0; i < form.validation.length; i++) {
      let v = form.validation[i];

      let validationRes = v(formValue);
      if (validationRes != null) {
        form.warning = validationRes;
        isValid = false;
      }
    }
  }
  return isValid;
};

const generateHmac512 = (text, secret) => {
  var hash = CryptoJS.HmacSHA512(text, secret).toString();
  return hash;
};

const generateSignature = (body, userKey, tstamp) => {
  let signatureStr = `${userKey}:${JSON.stringify(body)}:${tstamp}`;

  //generate hmac with secret key
  let hmac = MyPlugin.generateHmac512(signatureStr, config.secretKey);

  return hmac;
};

const generateUUID = () => {
  return uuidv4();
};

const MyPlugin = {
  strToDate,
  sanitizeInput,
  sampleFunction,
  formatDate,
  thousandSeparator,
  formatDateString,
  jsonReplacer,
  jsonPrettyPrint,
  isJson,
  isPhp,
  sanitizeWhitespace,
  checkPasswordStrength,
  checkValidEmail,
  checkValidPhoneNumber,
  checkWhiteSpace,
  generateHmac512,
  generateSignature,
  formValidation,
  singleFormValidation,
  generateUUID,
  // showAlert,
};

//the exported plugin must be registered in main.js
export default MyPlugin;
